import React from 'react';
import styles from './FormPageDisplay.scss';
import HeaderNavigation from '../../components/HeaderNavigation';
import { useTranslation } from 'react-i18next';
import SimpleButton from '../../components/SimpleButton';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'app/configureStore';
import TermAndConditionText from '../../components/TermAndConditionText';

const W9Certification = () => {
  const { t } = useTranslation();
  const legalTexts = useSelector((state: RootState) => state.applicationReducer.legalTexts);
  const w9c = legalTexts?.find((text) => text.legal_type === 'w9');
  const navigate = useNavigate();
  const onHandleBack = () => {
    navigate(-1);
  };
  return (
    <>
      <div className={styles.fixedHeader}>
        <HeaderNavigation />
      </div>

      <div className={styles.scrollableContent} style={{ marginTop: '130px' }}>
        <div className={styles.container}>
          <div className={styles.content}>
            {w9c && <TermAndConditionText {...w9c} />}
            <SimpleButton text={t('back')} onClick={onHandleBack} />
          </div>
        </div>
      </div>
    </>
  );
};

export default W9Certification;
